export default __webpack_public_path__ + "static/media/Barret-M82a1-Remote-03.edd3cc86.jpg";